import React from 'react';
import proptypes from 'prop-types';
const { string, arrayOf, shape } = proptypes;
import {
  Typography,
  Card
} from '@one-thd/sui-atomic-components';
import { MediaHotspots } from '@thd-olt-component-react/product-hotspots';

const ShopInspirationSection = React.memo(({ shopInspiration }) => {
  return (
    <>
      {shopInspiration?.map((image, index) => {
        return (
          <div
            key={`hotspot-${index}`}
            className="sui-col-span-12 xl:sui-col-span-6 md:sui-col-span-6 lg:sui-col-span-6"
          >
            <Card>
              <MediaHotspots hotspots={image?.hotspots} imageUrl={image?.imageUrl} />
            </Card>
          </div>
        );
      })}
    </>
  );
});

ShopInspirationSection.propTypes = {
  shopInspiration: arrayOf(shape({
    imageUrl: string,
    hotspots: arrayOf(shape({
      coordinate: shape({
        xCoordinate: string,
        yCoordinate: string
      }),
      omsIDs: arrayOf(string),
    }))
  })).isRequired
};

ShopInspirationSection.defaultProps = {};

export { ShopInspirationSection };
